// src/utils/openGuidePopup.js
export function openGuidePopup() {
  const w = 1100;
  const h = 800;
  const left = window.screenX + Math.max(0, (window.outerWidth - w) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - h) / 2);

  const features = [
    'popup=yes',
    `width=${w}`,
    `height=${h}`,
    `left=${left}`,
    `top=${top}`,
    'menubar=no',
    'toolbar=no',
    'location=no',
    'status=no',
    'resizable=yes',
    'scrollbars=yes',
    'noopener',     // reverse-tabnabbing 방지
  ].join(',');

  const win = window.open('/guide', 'AnalyzerGuide', features);
  if (win) {
    try { win.opener = null; } catch {}
    win.focus();
  }
}
